'use strict';

const App = require('../app');
const AuthView = require('./auth-view');
const { ApiClient } = require('./api-client');

const api = new ApiClient();
let game = null;
let authView = null;

function installLocalDevelopmentControls() {
  if (!['localhost', '127.0.0.1', '::1'].includes(location.hostname)) return;
  window.__STAR_DODGE_DEV__ = {
    get game() { return game; },
    openBoss(level, bossOverrides) {
      if (!game) throw new Error('Game is not ready');
      const normalizedLevel = Math.max(1, Math.min(99, Math.floor(Number(level) || 1)));
      const config = JSON.parse(JSON.stringify(game.gameConfig.getLevelConfig(normalizedLevel)));
      config.boss = { ...config.boss, ...(bossOverrides || {}) };
      game.performSwitch('boss', {
        runContext: { ranked: false, runId: null, level: normalizedLevel },
        config,
        survivalDurationMs: Math.round(config.duration * 1000),
        pauseCount: 0,
        pauseDurationMs: 0
      });
      return game.currentScene;
    },
    state() {
      const scene = game && game.currentScene;
      if (!scene) return null;
      return {
        scene: scene.constructor.name,
        state: scene.state || null,
        level: scene.level || null,
        playerLives: scene.playerLives,
        invulnerableRemaining: scene.invulnerableRemaining,
        remaining: scene.remaining,
        bossHealth: scene.boss && scene.boss.health,
        bossMaxHealth: scene.boss && scene.boss.maxHealth,
        bossRetryCount: scene.bossRetryCount,
        playerShots: scene.playerShots && scene.playerShots.activeCount(),
        projectiles: scene.projectiles && scene.projectiles.activeCount(),
        projectileName: scene.projectileProfile && scene.projectileProfile.projectileName,
        projectileRenderer: scene.projectileProfile && scene.projectileProfile.rendererKey,
        projectileMotion: scene.projectileProfile && scene.projectileProfile.motionKey,
        musicTrack: game.feedback.musicTrack,
        musicPaused: game.feedback.musicPaused,
        musicContextState: game.feedback.audioContext && game.feedback.audioContext.state,
        scheduledMusicNodes: game.feedback.musicSequencer && game.feedback.musicSequencer.activeNodes.size,
        paused: scene.paused
      };
    }
  };
  const requestedBossLevel = new URLSearchParams(location.search).get('boss');
  if (requestedBossLevel) {
    const openRequestedBoss = () => {
      if (!game.currentScene || game.currentScene === game.scenes.loading) {
        setTimeout(openRequestedBoss, 50);
        return;
      }
      window.__STAR_DODGE_DEV__.openBoss(requestedBossLevel);
    };
    openRequestedBoss();
  }
}

async function startGame(user) {
  if (game) game.stop();
  document.getElementById('account-name').textContent = user.username;
  const adminLink = document.getElementById('admin-link');
  adminLink.classList.toggle('hidden', user.role !== 'ADMIN');
  if (user.role === 'ADMIN') {
    fetch('/api/runtime', { credentials: 'same-origin' })
      .then((response) => response.json())
      .then((runtime) => {
        if (runtime.adminOrigin) adminLink.href = runtime.adminOrigin;
      })
      .catch(() => adminLink.classList.add('hidden'));
  }
  game = new App({
    canvas: document.getElementById('game-canvas'),
    apiClient: api,
    user,
    syncElement: document.getElementById('sync-status')
  });
  game.start();
  installLocalDevelopmentControls();
}

document.addEventListener('DOMContentLoaded', () => {
  authView = new AuthView(api, startGame);
  document.getElementById('logout-button').addEventListener('click', async () => {
    try { await api.logout(); } catch (error) { /* A local logout still closes the UI. */ }
    if (game) game.stop();
    game = null;
    authView.showAuth('已退出登录');
  });
  authView.initialize();
});
